import { Box, Stack, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { IconNames } from 'sprite/types';

import { borderedCardHover } from 'utils/styles.utils';

import LinkUnstyled from 'components/@common/LinkUnstyled';
import Icon from 'components/@icons/Icon';

type Contact = {
  iconName: IconNames;
  type: 'whatsapp' | 'email' | 'phone';
};

const ContactLookup: Array<Contact> = [
  {
    type: 'whatsapp',
    iconName: 'LogoWhatsapp',
  },
  {
    type: 'email',
    iconName: 'Email',
  },
  {
    type: 'phone',
    iconName: 'Support',
  },
];

const Contact = () => {
  const intl = useIntl();

  return (
    <Stack
      sx={{
        gap: 1,
      }}
    >
      {ContactLookup.map((contact, index) => (
        <Box
          key={index}
          component={LinkUnstyled}
          href={intl.formatMessage({ id: `contact.${contact.type}.href` })}
          target="_blank"
          sx={[
            {
              display: 'flex',
              gap: 0.5,
              justifyContent: 'space-between',
              p: 2,
              borderRadius: 2,
            },
            (theme) => ({
              ...borderedCardHover(theme),
              alignItems: 'center',
              ...(index === 0 && {
                // Highlight the first contact option
                backgroundColor: theme.vars.palette.grey[900],
              }),
            }),
          ]}
        >
          <Box
            sx={{
              display: 'flex',
              gap: 1,
            }}
          >
            <Icon name={contact.iconName} />
            <Stack
              sx={{
                gap: 0.5,
              }}
            >
              <Typography
                variant="small"
                sx={{
                  fontWeight: 'bold',
                }}
              >
                {intl.formatMessage({ id: `contact.${contact.type}.title` })}
              </Typography>
              <Typography
                variant="extraSmall"
                sx={{
                  color: 'grey.600',
                }}
              >
                {intl.formatMessage({
                  id: `contact.${contact.type}.description`,
                })}
              </Typography>
              <Typography
                component="bdi"
                variant="extraSmall"
                sx={{
                  alignSelf: 'flex-start',
                  color: 'grey.600',
                }}
              >
                {intl.formatMessage({ id: `contact.${contact.type}.info` })}
              </Typography>
            </Stack>
          </Box>
          <Icon name="ChevronRight" fontSize={20} rotateInArabic />
        </Box>
      ))}
    </Stack>
  );
};

export default Contact;
